var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal"}},[(_vm.showModal)?_c('div',[_c('div',{staticClass:"modal-mask"},[_c('div',{ref:"overlay",staticClass:"modal-wrapper",on:{"click":_vm.hideIfOverlay}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._t("default")],2)])])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }